import { str_replace } from '../../../utils/helper/helper_string';
export class UserPermissionEvaluator {
    parent;
    permissionRow;
    constructor(parent, row) {
        this.parent = parent;
        this.permissionRow = row;
    }
    get userPermission() {
        return this.parent;
    }
    get regexString() {
        return str_replace('%', '(.*)', this.permissionRow.path);
    }
    get regex() {
        return new RegExp(this.regexString, 'i');
    }
    get currentLocationPath() {
        return this.userPermission.app.pathURI;
    }
    get isMatching() {
        return this.regex.test(this.currentLocationPath);
    }
    get hasEditPermissionsForCurrentLocation() {
        return this.isMatching && this.permissionRow.edit;
    }
    get hasAdminPermissionsForCurrentLocation() {
        return this.isMatching && this.permissionRow.administrate;
    }
}
